// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-SongControls-module__progressBar-gWHJ4 {
  cursor: pointer;
  height: 4px;
  width: 100%;
  background-color: var(--border-secondary);
  transition-property: height;
  transition-duration: 0.2s;
}

.nightbot-SongControls-module__progressBar-gWHJ4:hover {
  height: 8px;
}

.nightbot-SongControls-module__controlsContainer-YmuXH {
  display: flex;
  align-items: center;
  padding: 16px;
}

.nightbot-SongControls-module__volumeControls-Nq50J {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.nightbot-SongControls-module__buttonGroup-BlDvX {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
  gap: 16px;
}

.nightbot-SongControls-module__songActions-Yo2N_ {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.nightbot-SongControls-module__volumeSlider-MumbH {
  width: 100px;

  --track-bg: var(--border-primary);
}

@media (max-width: 768px) {

.nightbot-SongControls-module__volumeSlider-MumbH {
    display: none;
}
  }

.nightbot-SongControls-module__progress-aj9Qd {
  height: 100%;
  background-color: var(--mantine-primary-color-filled);
}
`, "",{"version":3,"sources":["webpack://./src/components/song_requests/SongControls.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,YAAY;;EAEZ,iCAAiC;AAInC;;AAHE;;AAJF;IAKI,aAAa;AAEjB;EADE;;AAGF;EACE,YAAY;EACZ,qDAAqD;AACvD","sourcesContent":[".progressBar {\n  cursor: pointer;\n  height: 4px;\n  width: 100%;\n  background-color: var(--border-secondary);\n  transition-property: height;\n  transition-duration: 0.2s;\n}\n\n.progressBar:hover {\n  height: 8px;\n}\n\n.controlsContainer {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n}\n\n.volumeControls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.buttonGroup {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  justify-content: center;\n  gap: 16px;\n}\n\n.songActions {\n  display: flex;\n  flex: 1;\n  justify-content: flex-end;\n}\n\n.volumeSlider {\n  width: 100px;\n\n  --track-bg: var(--border-primary);\n  @media (max-width: $mantine-breakpoint-sm) {\n    display: none;\n  }\n}\n\n.progress {\n  height: 100%;\n  background-color: var(--mantine-primary-color-filled);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressBar": `nightbot-SongControls-module__progressBar-gWHJ4`,
	"controlsContainer": `nightbot-SongControls-module__controlsContainer-YmuXH`,
	"volumeControls": `nightbot-SongControls-module__volumeControls-Nq50J`,
	"buttonGroup": `nightbot-SongControls-module__buttonGroup-BlDvX`,
	"songActions": `nightbot-SongControls-module__songActions-Yo2N_`,
	"volumeSlider": `nightbot-SongControls-module__volumeSlider-MumbH`,
	"progress": `nightbot-SongControls-module__progress-aj9Qd`
};
export default ___CSS_LOADER_EXPORT___;
